import { useState, useEffect } from 'react'
import { Command, ChevronUp, ChevronDown, Search } from 'lucide-react'
import { cn } from '../../lib/utils'

export interface ShortcutsWidgetProps {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  onPriceCheck?: () => void
}

export function ShortcutsWidget({ expanded, setExpanded, onPriceCheck }: ShortcutsWidgetProps) {
  const shortcuts = [
    { key: 'F2 / Alt+B', action: 'Buscar Producto' },
    { key: 'F8 / Alt+P', action: 'Cobrar' },
    { key: 'Alt+L', action: 'Vaciar Carrito' },
    { key: 'Alt+S', action: 'Venta a Domicilio' },
    { key: 'Alt+W', action: 'Recargas y Servicios' },
    { key: 'Alt+↑', action: 'Aumentar cantidad de producto' },
    { key: 'Alt+↓', action: 'Disminuir cantidad de producto' },
    { key: 'Alt+Del', action: 'Eliminar producto del carrito' },
    { key: 'Alt+R', action: 'Retiro de Efectivo' },
    { key: 'Alt+D', action: 'Depósito a Caja' },
    { key: 'Alt+C', action: 'Corte de Caja' },
    { key: 'Alt+X', action: 'Liberar Caja' },
    { key: 'F4', action: 'Consulta Rápida de Precio' },
    { key: 'Esc', action: 'Cerrar Modales / Limpiar Búsqueda' },
  ]

  return (
    <div className="flex flex-col items-start">
      {expanded && (
        <div className="mb-2 w-[340px] rounded-lg border border-slate-200 bg-white shadow-xl overflow-hidden animate-in fade-in slide-in-from-bottom-4">
          <div className="bg-slate-50 border-b border-slate-100 p-3 flex justify-between items-center">
            <h3 className="font-semibold text-sm text-slate-800 flex items-center gap-2">
              <Command className="h-4 w-4" />
              Atajos de Teclado
            </h3>
            <button
              onClick={() => setExpanded(false)}
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <ChevronDown className="h-4 w-4" />
            </button>
          </div>
          <div className="max-h-80 overflow-y-auto p-2">
            <table className="w-full text-xs">
              <tbody>
                {shortcuts.map((s, i) => (
                  <tr key={i} className="hover:bg-slate-50 border-b border-slate-50 last:border-0">
                    <td className="py-2 px-3 text-slate-600">{s.action}</td>
                    <td className="py-2 px-3 text-right">
                      <kbd className="inline-flex items-center justify-center rounded border border-slate-200 bg-slate-100 px-1.5 font-mono text-[10px] font-medium text-slate-600 whitespace-nowrap">
                        {s.key}
                      </kbd>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="flex items-center gap-3">
        <button
          onClick={() => setExpanded(!expanded)}
          className={cn(
            "flex items-center gap-2 rounded-full border shadow-sm transition-all duration-200",
            expanded
              ? "bg-slate-100 border-slate-200 text-slate-500 px-3 py-1.5 text-xs hover:bg-slate-200"
              : "bg-white border-primary/20 text-primary px-4 py-2 text-sm hover:border-primary/30 shadow-md"
          )}
        >
          <Command className={expanded ? "h-3 w-3" : "h-4 w-4"} />
          <span className="font-medium">
            {expanded ? 'Ocultar comandos' : '[F10] Comandos Rápidos'}
          </span>
          {!expanded && <ChevronUp className="h-4 w-4 opacity-70" />}
        </button>
      {!expanded && onPriceCheck && (
        <button
          onClick={onPriceCheck}
          className={cn(
            "flex items-center gap-2 rounded-full border shadow-sm transition-all duration-200",
            "bg-white border-primary/20 text-primary px-4 py-2 text-sm hover:border-primary/30 shadow-md"
          )}
        >
          <Search className="h-4 w-4" />
          <span className="font-medium">
            [F4] Consulta Rápida
          </span>
        </button>
      )}
      </div>
    </div>
  )
}
